import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useTextSetsGet = () => {
  const resource = `${MONOLITH_ORIGIN}/api/v3/content/selector/created-by-me/?depth=2&shape=card&type=text_set`;
  return useRestQuery(resource);
};

export default useTextSetsGet;
